import React from "react";
import clsx from "clsx";
import "../../../assets/css/form-steps.css";

export function FormStepIndicator({ activeStep, stepNumber, title }) {
    const isActive = activeStep >= stepNumber;
    
    const className = clsx({
        'form-step': true,
        'form-step-active': isActive
    });

    return (
        <div className="form-step-wrapper">
            <div className={className}>
                <p>
                    {stepNumber + 1}
                </p>
            </div>

            <p>
                {title}
            </p>
        </div>
    );
}